import CircularLoader from "@/components/loading/LoadingComponent";
import { gql, useQuery } from "@apollo/client";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const RUNESTONE_CHECK_QUERY = gql`
    query RunestoneCheck {
        myAccount {
            hasRunestone
            isStreamTeamAcademy
        }
    }
`;

interface GuardProps {
    children: React.ReactNode;
}

const AlreadyHasRunestoneGuard = ({ children }: GuardProps) => {
    const navigate = useNavigate();
    const { data, loading } = useQuery(RUNESTONE_CHECK_QUERY);
    const shouldBlock =
        Boolean(data?.myAccount?.hasRunestone) ||
        Boolean(data?.myAccount?.isStreamTeamAcademy);

    useEffect(() => {
        if (!loading && shouldBlock) {
            navigate("/dashboard/my-account");
        }
    }, [loading, navigate, shouldBlock]);

    if (loading) {
        return <CircularLoader />;
    }

    return shouldBlock ? null : <>{children}</>;
};

export default AlreadyHasRunestoneGuard;
